import React from "react";
import { SendGiftContext } from "features/send-gift/contexts";

export const useSendGiftContext = () => React.useContext(SendGiftContext);
